import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

/** Mặc định bypass check quyền menu / chức năng (dev). Đặt false khi cần RBAC thật. */
const BYPASS_CHUC_NANG = true

export const useMenuChucNang = () => {
    const { webUrls, webChucNangs, webChucNangAll, loading, error } = useSelector((state: RootState) => state.menu);

    const hasMenu = useCallback((urlPath: string): boolean => {
        if (BYPASS_CHUC_NANG) return true
        if (!webUrls || webUrls.length === 0) return true
        return webUrls.includes(urlPath)
            || webUrls.some((u) => u === urlPath || urlPath.startsWith(`${u}/`) || u.startsWith(`${urlPath}/`))
    }, [webUrls]);

    const hasChucNang = useCallback((_urlPath: string, chucNangCode: string): boolean => {
        if (BYPASS_CHUC_NANG) return true
        if (webChucNangs.length === 0 && webChucNangAll.length > 0) {
            return webChucNangAll.includes(chucNangCode);
        }
        const tabData = webChucNangs.find((item: { url: string; chucNangs: string[] }) => {
            return item.url === _urlPath;
        });
        return tabData ? tabData.chucNangs.includes(chucNangCode) : false;
    }, [webChucNangs, webChucNangAll]);

    const getChucNangsByTab = useCallback((urlPath: string): string[] => {
        const tabData = webChucNangs.find((item: { url: string; chucNangs: string[] }) => item.url === urlPath);
        return tabData ? tabData.chucNangs : [];
    }, [webChucNangs]);

    const hasChucNangByCode = useCallback((chucNangCode: string): boolean => {
        if (BYPASS_CHUC_NANG) return true
        if (!webChucNangAll || webChucNangAll.length === 0) return true
        return webChucNangAll.includes(chucNangCode)
    }, [webChucNangAll]);

    return {
        webUrls,
        webChucNangs,
        webChucNangAll,
        loading,
        error,
        hasMenu,
        hasChucNang,
        getChucNangsByTab,
        hasChucNangByCode,
    };
};
